<template>
  <b-card class="bg-white rounded-xl px-4 eventss">
    <el-drawer
      :title="`${action} well being intiatives`"
      :visible.sync="drawer"
      :direction="direction"
      :before-close="handleClose"
    >
      <ValidationObserver
        tag="form"
        ref="obs1"
        @submit.prevent="addWellBeingIData()"
        class="bg-white h-100"
      >
        <div class="px-5 pt-4">
          <label class="fsize16 text-dark font-semibold">Image</label><br>
          <div
            class="text-sm text-gray-600 font-medium px-2 py-1 mb-1 border rounded bg-gray-100 inline-block"
          >
            Recommended Size: 500 × 500px
          </div>
          <!-- <ValidationProvider rules="image" v-slot="{ errors }"> -->
          <div>
            <FileUploader
              v-show="!image"
              :image="image"
              :onSuccess="handleSuccess"
              class="w-full my-1 m-auto display-none custmodal"
            />
            <!-- <span class="fsize12 text-danger">{{ errors[0] }}</span>
          </ValidationProvider> -->

            <div v-if="action != 'Edit'">
              <img
                v-if="image"
                :src="image"
                ref="cover"
                class="w-full my-1 m-auto display-none custmodal"
              />
              <div
                class="flex justify-center text-red"
                v-if="image"
                @click="handleRemove"
              >
                Remove image
              </div>
            </div>

            <div v-else>
              <img
                v-if="image"
                :src="
                  image.slice(0, 4) === 'data' ? image : `${$imageURL}/${image}`
                "
                ref="cover"
                class="rounded-full widtht20percent m-auto display-none custmodal"
              />
              <div
                class="text-center text-red"
                v-if="image"
                @click="handleRemove"
              >
                Edit image
              </div>
            </div>
            <span
              v-if="imageErr"
              class="flex justify-center small text-danger"
              >{{ msg.image }}</span
            >
          </div>
          <p class="fsize12 text-danger" v-if="showValidationErr">
            {{ validationErr }}
          </p>

          <div class="">
            <label class="fsize16 text-dark font-semibold">Title</label>
            <ValidationProvider
              name="Title"
              rules="required"
              v-slot="{ errors }"
            >
              <el-input
                placeholder="Please input"
                class="w-full"
                v-model="initiativeTitle"
              ></el-input>
              <span class="fsize12 text-danger">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div class="mt-4">
            <label class="fsize16 text-dark font-semibold">Description</label>
            <ValidationProvider
              name="Description"
              rules="required"
              v-slot="{ errors }"
            >
              <el-input
                placeholder="Please input"
                class="w-full"
                type="textarea"
                rows="5"
                v-model="initiativeDesp"
              ></el-input>
              <span class="fsize12 text-danger">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div class="mt-4">
            <label
              class="fsize16 text-dark flex gap-2 items-center font-semibold"
              >URL
            </label>
            <div class="flex items-center gap-2">
              <img
                id="icon"
                ref="cover"
                class="rounded-full widtht20percent display-none custmodal"
              />
              <ValidationProvider
                name="Url"
                rules="required"
                v-slot="{ errors }"
              >
                <el-input
                  placeholder="Please input"
                  id="initiativeUrl"
                  class="w-full"
                  v-model="initiativeUrl"
                ></el-input>
                <span class="fsize12 text-danger">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="mt-5 flex justify-center">
            <base-button
              outline
              class="px-8 fsize14 py-2 mx-1"
              type="primary"
              @click="
                action == 'Add' ? addWellBeingIData() : editWellBeingIData()
              "
            >
              Submit
            </base-button>
          </div>
        </div>
      </ValidationObserver>
    </el-drawer>

    <div class="flex justify-between items-center">
      <div>
        <h2 class="text-2xl font-semibold">Well-being Initiatives</h2>
      </div>
      <base-button
        outline
        class="px-6 py-1 mx-1"
        type="primary"
        @click="actionPerform('', 'Add')"
      >
        <span class="btn-inner--text flex justify-between items-center"
          ><feather-icon icon="PlusIcon" class="cust-HW"></feather-icon> Add
          Initiatives
        </span>
      </base-button>
    </div>
    <div class="mt-5">
      <b-input-group class="">
        <b-form-input
          class="border-none shadow-lg"
          type="text"
          min="0.00"
          v-model="search"
          placeholder="Enter Search...."
          v-on:input="searchBy"
        ></b-form-input>

        <b-input-group-append>
          <b-button
            variant="white"
            class="flex items-center shadow-lg"
            aria-label="search"
          >
            <feather-icon
              class="cursor-pointer mr-2"
              icon="SearchIcon"
              svgClasses="w-4 h-4"
            ></feather-icon>
          </b-button>
        </b-input-group-append>
      </b-input-group>
      <el-table
        class="table-responsive table-flush mt-6"
        header-row-class-name="thead-light table-th-color"
        :data="tableData"
        border
      >
        <el-table-column
          label="Title"
          min-width="250px"
          prop="heading"
          class="ml-12"
          sortable
        >
          <template v-slot="{ row }">
            <p class="font-semibold text-left name mb-0 text-sm">
              {{ row.title }}
            </p>
          </template>
        </el-table-column>
        <el-table-column
          label="Description"
          min-width="250px"
          prop="heading"
          class="ml-12"
          sortable
        >
          <template v-slot="{ row }">
            <p class="font-semibold text-left name mb-0 text-sm">
              {{ row.description }}
            </p>
          </template>
        </el-table-column>
        <el-table-column
          label="Image"
          min-width="250px"
          prop="heading"
          class="ml-12"
          sortable
        >
          <template v-slot="{ row }">
            <img
              v-if="row.hasOwnProperty('bannerImage') && row.bannerImage != ''"
              :src="`${$imageURL}/${row.bannerImage}`"
              :alt="image"
            />
            <img
              v-else
              :src="`${$imageURL}/caregiversaathi/default/dummy%20image.jpg`"
              :alt="image"
            />
          </template>
        </el-table-column>
        <el-table-column
          label="Created Date"
          min-width="250px"
          prop="heading"
          class="ml-12"
          sortable
        >
          <template v-slot="{ row }">
            <p class="font-semibold text-left name mb-0 text-sm">
              {{ getDate(row.createdAt) }}
            </p>
          </template>
        </el-table-column>
        <el-table-column
          label="URL"
          min-width="250px"
          prop="description"
          class="ml-12"
          sortable
        >
          <template v-slot="{ row }">
            <p class="font-semibold text-left name mb-0 text-sm">
              {{ row.url }}
            </p>
          </template>
        </el-table-column>

        <el-table-column
          label="Actions"
          min-width="100px"
          class-name="text-center"
        >
          <template v-slot="{ row }">
            <div class="flex justify-center items-center gap-1">
              <feather-icon
                @click="actionPerform(row, 'Edit')"
                icon="EditIcon"
                svgClasses="w-4 h-4 text-blue-500 cursor-pointer"
              ></feather-icon>
              <feather-icon
                icon="Trash2Icon"
                @click="deleteWellBeingData(row)"
                svgClasses="w-4 h-4 text-red-600 cursor-pointer"
              ></feather-icon>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="mt-5 flex justify-end">
      <el-pagination
        @current-change="
          (value) => {
            currentPage = value;
            getWellBeingData();
          }
        "
        layout="prev,pager,next"
        :per-size="10"
        :total="pageCount"
      >
      </el-pagination>
    </div>
  </b-card>
</template>

<script>
import FileUploader from "@/components/FileUploader";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { extend } from "vee-validate";
import * as rules from "vee-validate/dist/rules";
extend("required", {
  ...rules.required,
  message: "This field is required",
});
extend("integer", {
  ...rules.integer,
  message: "This field must be an integer",
});
import moment from "moment";
export default {
  data() {
    return {
      drawer: false,
      direction: "rtl",

      // pagination
      currentPage: 1,
      pageCount: 0,

      // search
      search: "",
      tableData: [],

      // add/edit initiative
      action: "",
      selectedId: "",
      selectedItem: "",
      initiativeTitle: "",
      initiativeDesp: "",
      initiativeUrl: "",

      // image
      showValidationErr: false,
      validationErr: "This field is required",
      image: null,
      coverImage: null,
      imageErr: false,
      msg: {
        image: "",
      },
    };
  },
  components: {
    FileUploader,
    ValidationObserver,
    ValidationProvider,
    rules,
    extend,
  },
  methods: {
    searchBy: _.debounce(function (e) {
      this.getWellBeingData();
    }, 500),
    getDate(date) {
      return moment(date).format("MMMM Do YYYY, h:mm a");
    },
    async getWellBeingData() {
      let offset = 0;
      let payload = {
        pagination: true,
      };

      if (this.currentPage == 1) {
        Object.assign(payload, { offset: offset });
      } else {
        offset = 10 * this.currentPage - 10;
        Object.assign(payload, { offset: offset });
      }
      if (this.search != "") {
        Object.assign(payload, { search: this.search });
      }
      let result = await this.$store.dispatch(
        "wellBeingInitaitive/getWellIntiatives",
        payload
      );
      console.log(result, "RESULT");
      this.tableData = result.data.data;
      this.pageCount = result.data.count;
    },
    clearAll() {
      this.action = "";
      this.selectedId = "";
      this.initiativeTitle = "";
      this.initiativeDesp = "";
      this.initiativeUrl = "";
      this.image = "";
      this.coverImage = "";

      let inputICON = document.getElementById("icon");
      inputICON.src = "";
    },
    handleClose() {
      this.drawer = false;
      this.clearAll();
    },
    actionPerform(VALUE, ACTION) {
      if (ACTION == "Add") {
        this.drawer = true;
        this.action = ACTION;
      } else if (ACTION == "Edit") {
        this.drawer = true;
        this.action = ACTION;
        this.selectedItem = VALUE;
        this.selectedId = VALUE._id;
        this.initiativeTitle = VALUE.hasOwnProperty("title") ? VALUE.title : "";
        this.initiativeDesp = VALUE.hasOwnProperty("description")
          ? VALUE.description
          : "";
        this.initiativeUrl = VALUE.hasOwnProperty("url") ? VALUE.url : "";
        this.image = VALUE.hasOwnProperty("bannerImage")
          ? VALUE.bannerImage
          : "";
      }
    },
    async addWellBeingIData() {
      if (this.image == "" || this.image == null) {
        this.showValidationErr = true;
      } else {
        this.showValidationErr = false;
      }
      this.$refs.obs1.validate().then(async (success) => {
        if (success) {
          if (this.image != "" && this.coverImage != "") {
            const payload = new FormData();
            payload.append("title", this.initiativeTitle);
            payload.append("description", this.initiativeDesp);
            payload.append("url", this.initiativeUrl);
            payload.append("bannerImage", this.coverImage);
            let result = await this.$store.dispatch(
              "wellBeingInitaitive/addWellIntiatives",
              payload
            );
            this.coverImage = "";
            this.image = "";
          } else {
            let payload = {};
            if (this.initiativeTitle != "") {
              Object.assign(payload, { title: this.initiativeTitle });
            }
            if (this.initiativeDesp != "") {
              Object.assign(payload, { description: this.initiativeDesp });
            }
            if (this.initiativeUrl != "") {
              Object.assign(payload, { url: this.initiativeUrl });
            }
            let result = await this.$store.dispatch(
              "wellBeingInitaitive/addWellIntiatives",
              payload
            );
          }
          await this.clearAll();
          await this.handleClose();
          await this.getWellBeingData();
        }
      });
    },
    async editWellBeingIData() {
      const payload = new FormData();
      payload.append("_id", this.selectedId);
      if (
        this.selectedItem.hasOwnProperty("title") &&
        this.initiativeTitle != this.selectedItem.title
      ) {
        payload.append("title", this.initiativeTitle);
      }

      if (
        this.selectedItem.hasOwnProperty("description") &&
        this.initiativeDesp != this.selectedItem.description
      ) {
        payload.append("description", this.initiativeDesp);
      }

      if (
        this.selectedItem.hasOwnProperty("url") &&
        this.initiativeUrl != this.selectedItem.url
      ) {
        payload.append("url", this.initiativeUrl);
      }

      if (
        this.selectedItem.hasOwnProperty("bannerImage") &&
        this.image != this.selectedItem.bannerImage
      ) {
        payload.append("bannerImage", this.coverImage);
      }

      let result = await this.$store.dispatch(
        "wellBeingInitaitive/editWellIntiatives",
        payload
      );
      await this.clearAll();
      await this.handleClose();
      await this.getWellBeingData();
    },
    async deleteWellBeingData(ITEM) {
      let result = await this.$store.dispatch(
        "wellBeingInitaitive/deleteWellIntiatives",
        {
          _id: ITEM._id,
          isDeleted: true,
        }
      );
      await this.getWellBeingData();
    },
    handleSuccess(image) {
      let mByte = 5 * 1048576;
      if (image.size > mByte) {
        this.$swal.fire({
          title: "File size exceeds the allowed limit!",
          // text: "Please ensure that the file size does not exceed 5MB",
          html: "<p style='text-align:center'>Please ensure that the file size does not exceed 5MB</p>",
          confirmButtonText: "Okay",
          icon: "warning",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        return;
      }
      this.imageErr = false;
      if (!image.type.includes("image")) {
        this.imageErr = true;
        this.msg.image = "Upload Image Only";
      } else {
        this.imageErr = false;

        this.coverImage = image;
        this.readerData(image);
      }
    },
    readerData(rawFile) {
      let loader = this.$loading();
      const reader = new FileReader();
      reader.onload = (e) => {
        this.$emit("load", (this.image = e.target.result));
        loader.close();
      };
      reader.readAsDataURL(rawFile);
    },
    handleRemove() {
      this.image = null;
      this.coverImage = null;
    },
    // parseURL(doc) {
    //   var favICON = null;
    //   var parser = new DOMParser();
    //   var doc1 = parser.parseFromString(doc, "text/html");
    //   var nodeList = doc1.getElementsByTagName("link");
    //   for (var i = 0; i < nodeList.length; i++) {
    //     if (
    //       nodeList[i].getAttribute("rel") == "icon" ||
    //       nodeList[i].getAttribute("rel") == "shortcut icon"
    //     ) {
    //       favICON = nodeList[i].getAttribute("href");
    //       break;
    //     }
    //   }
    //   return favICON;
    //   // inputICON.src = favICON;
    //   // inputICON.src = FICON;
    // },
    async getUrlFavIcon() {
      let inputURL = document.getElementById("initiativeUrl");
      let inputICON = document.getElementById("icon");

      // const FICON = `https://favicons.githubusercontent.com/${inputURL.value}`;
      // const FICON = `${inputURL.value}/favicon.ico`;
      // const FICON = `https://favicongrabber.com/api/grab/${inputURL.value}`;
      // const FICON = `https://s2.googleusercontent.com/s2/favicons?domain=${inputURL.value}`;
      const FICON = `https://s2.googleusercontent.com/s2/favicons?domain=${this.initiativeUrl}`;
      inputICON.src = FICON;

      // await fetch(this.initiativeUrl)
      //   .then((res) => {
      //     return res.text();
      //   })
      //   .then((html) => {
      //   var FAV_ICON = this.parseURL(html);
      //   if (FAV_ICON) {
      //     fetch(FAV_ICON)
      //       .then((res) => res.blob())
      //       .then((blob) => {
      //         var faviconImg = URL.createObjectURL(blob);
      //         inputICON.src = faviconImg;
      //       });
      //   }
      // });
    },
  },
  async mounted() {
    await this.getWellBeingData();
  },
  watch: {
    initiativeUrl(value) {
      if (value) {
        this.getUrlFavIcon();
      }
    },
    drawer(value) {
      if (value == false) {
        this.$refs["obs1"].reset();
        this.$refs["obs1"].resetValidation();
      }
    },
    image(value) {
      if (value != "" && value != null) {
        this.showValidationErr = false;
      }
    },
  },
};
</script>
